// Generated by ReScript, PLEASE EDIT WITH CARE


function getInitialBasicTicketInfo(param) {
  return {
          msisdn: undefined,
          crn: undefined,
          location: undefined,
          caller_number: undefined,
          order_stage: undefined,
          raised_by: undefined,
          crt_id: undefined
        };
}

function getInitialIssueFormData(param) {
  return {
          selected_issue: /* [] */0,
          issue_comment: undefined
        };
}

function getInitialActionFormData(param) {
  return {
          selected_actions: /* [] */0,
          action_comment: undefined
        };
}

var intitial_state_selected_basic_info = {
  msisdn: undefined,
  crn: undefined,
  location: undefined,
  caller_number: undefined,
  order_stage: undefined,
  raised_by: undefined,
  crt_id: undefined
};

var intitial_state_issue_form_data = {
  selected_issue: /* [] */0,
  issue_comment: undefined
};

var intitial_state_action_form_data = {
  selected_actions: /* [] */0,
  action_comment: undefined
};

var intitial_state = {
  current_view: /* BasicInfoForm */0,
  ticket_info: /* Init */0,
  issues: /* Init */0,
  actions: /* Init */0,
  selected_basic_info: intitial_state_selected_basic_info,
  issue_form_data: intitial_state_issue_form_data,
  action_form_data: intitial_state_action_form_data,
  snackbar_message: undefined,
  create_ticket_response: /* Init */0
};

function reducer(state, action) {
  if (typeof action === "number") {
    return {
            current_view: state.current_view,
            ticket_info: state.ticket_info,
            issues: state.issues,
            actions: state.actions,
            selected_basic_info: state.selected_basic_info,
            issue_form_data: state.issue_form_data,
            action_form_data: state.action_form_data,
            snackbar_message: undefined,
            create_ticket_response: state.create_ticket_response
          };
  }
  switch (action.TAG | 0) {
    case /* SetTicketInfo */0 :
        var ticket_info = action.ticket_info;
        var tmp;
        tmp = typeof ticket_info === "number" || ticket_info.TAG !== /* Live */1 ? ({
              msisdn: undefined,
              crn: undefined,
              location: undefined,
              caller_number: undefined,
              order_stage: undefined,
              raised_by: undefined,
              crt_id: undefined
            }) : ticket_info._0;
        return {
                current_view: state.current_view,
                ticket_info: ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: tmp,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* SetAvailableIssues */1 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: action.issues,
                actions: state.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* SetAvailableActions */2 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: action.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* UpdateView */3 :
        return {
                current_view: action.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* UpdateBasicInfoFormData */4 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: action.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* UpdateIssueFormData */5 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: action.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* UpdateActionFormData */6 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: action.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* OpenSnackbar */7 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: action.snackbar_message,
                create_ticket_response: state.create_ticket_response
              };
    case /* UpdateCreateTicketResponse */8 :
        return {
                current_view: state.current_view,
                ticket_info: state.ticket_info,
                issues: state.issues,
                actions: state.actions,
                selected_basic_info: state.selected_basic_info,
                issue_form_data: state.issue_form_data,
                action_form_data: state.action_form_data,
                snackbar_message: state.snackbar_message,
                create_ticket_response: action.create_ticket_response
              };
    
  }
}

export {
  getInitialBasicTicketInfo ,
  getInitialIssueFormData ,
  getInitialActionFormData ,
  intitial_state ,
  reducer ,
  
}
/* No side effect */
